/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-bill-payment.reducer';

export const PharmacyBillPaymentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyBillPaymentEntity = useAppSelector(state => state.pharmacyBillPayment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyBillPaymentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.detail.title">PharmacyBillPayment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.id}</dd>
          <dt>
            <span id="paymentMethod">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.paymentMethod">Payment Method</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.paymentMethod}</dd>
          <dt>
            <span id="transactionDetails">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.transactionDetails">Transaction Details</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.transactionDetails}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.paidAmount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="tmCursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.tmCursor">Tm Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.tmCursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.lastupdated}</dd>
          <dt>
            <span id="settledAtHospital">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.settledAtHospital">Settled At Hospital</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.settledAtHospital ? 'true' : 'false'}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.modifiedByID}</dd>
          <dt>
            <span id="paymentStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.paymentStatus">Payment Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.paymentStatus}</dd>
          <dt>
            <span id="forCredit">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.forCredit">For Credit</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.forCredit ? 'true' : 'false'}</dd>
          <dt>
            <span id="voided">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.voided">Voided</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.voided ? 'true' : 'false'}</dd>
          <dt>
            <span id="voidedReason">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.voidedReason">Voided Reason</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.voidedReason}</dd>
          <dt>
            <span id="voidedDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.voidedDate">Voided Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillPaymentEntity.voidedDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.pharmacyBill">Pharmacy Bill</Translate>
          </dt>
          <dd>{pharmacyBillPaymentEntity.pharmacyBill ? pharmacyBillPaymentEntity.pharmacyBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.collectedBy">Collected By</Translate>
          </dt>
          <dd>{pharmacyBillPaymentEntity.collectedBy ? pharmacyBillPaymentEntity.collectedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.subscriber">Subscriber</Translate>
          </dt>
          <dd>{pharmacyBillPaymentEntity.subscriber ? pharmacyBillPaymentEntity.subscriber.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.hospitalPayment">Hospital Payment</Translate>
          </dt>
          <dd>{pharmacyBillPaymentEntity.hospitalPayment ? pharmacyBillPaymentEntity.hospitalPayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.claim">Claim</Translate>
          </dt>
          <dd>{pharmacyBillPaymentEntity.claim ? pharmacyBillPaymentEntity.claim.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-bill-payment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-bill-payment/${pharmacyBillPaymentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyBillPaymentDetail;
